const AllGeneralTraining = () => import("./views/AllGeneralTraining.vue");
const ApprovalTraining = () => import("./views/ApprovalTraining.vue");
const ViewTrainingDetails = () => import("./views/ViewTrainingDetails.vue");
const AllPerformanceImprovementPlan = () =>
  import("./views/AllPerformanceImprovementPlan.vue");
const CreatePerformanceImprovementPlan = () =>
  import("./views/CreatePerformanceImprovementPlan.vue");
const EditPerformanceImprovementPlan = () =>
  import("./views/EditPerformanceImprovementPlan.vue");
const Settings = () => import("./views/Settings.vue");
const SettingsGeneral = () => import("./views/SettingsGeneral.vue");
const SettingsPerformance = () => import("./views/SettingsPerformance.vue");
const AssignEmployee = () => import("./views/AssignEmployee.vue");
const SettingsViewTraining = () => import("./views/SettingsViewTraining.vue");

export default [
  {
    path: "general-training",
    component: AllGeneralTraining,
  },
  {
    path: "general-training/view/:id",
    component: ViewTrainingDetails,
  },
  {
    path: "performance-improvement-plan",
    component: AllPerformanceImprovementPlan,
  },
  {
    path: "approval",
    component: ApprovalTraining,
  },
  {
    path: "performance-improvement-plan/create",
    component: CreatePerformanceImprovementPlan,
  },
  {
    path: "performance-improvement-plan/edit/:id",
    component: EditPerformanceImprovementPlan,
  },
  {
    path: "settings",
    component: Settings,
  },
  {
    path: "manage-general-settings",
    component: SettingsGeneral,
  },
  {
    path: "settings-general-training/view/:id",
    component: SettingsViewTraining,
  },
  {
    path: "manage-performance-improvement",
    component: SettingsPerformance,
  },
  {
    path: "settings/assign-employee",
    component: AssignEmployee,
  },
];
